import request from '@/utils/request';

/**
 *
 *  根据条件查询部门列表
 */
export function getDepartList(params) {
  return request({
    url: `/op/department/`,
    method: 'get',
    params: params
  });
}

/**
 *   新增
 * @param {*} form
 */
export function addDepart(form) {
  return request({
    url: `/op/department/add`,
    method: 'post',
    data: form
  });
}

/**
 *   编辑
 * @param {*} form
 */
export function editDepart(form) {
  return request({
    url: `/op/department/modify/${form.id}`,
    method: 'post',
    data: form
  });
}
/**
 *   禁用/启用
 * @param {*} form
 */
export function batchDepart(form) {
  return request({
    url: `/op/department/modifystatus`,
    method: 'post',
    data: form
  });
}

// 删除
export function deleteDepart(option) {
  return request({
    url: `/op/department/${option.id}`,
    method: 'delete',
    data: option
  });
}
